export default __webpack_public_path__ + "static/media/l5.30b1a5cf.png";